import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { Dot } from '~/UIKit';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 2px',
  },
}));

export interface DotsProps {
  color?: string;
}

export const Dots = ({ color = PRIMARY_BLUE }: DotsProps) => {
  const { classes } = useStyles();
  return (
    <div
      data-testid="loading"
      className={classes.container}
      onClick={() => void 0}
      onChange={() => void 0}
    >
      <Dot color={color} delay={0} />
      <Dot color={color} delay={0.2} />
      <Dot color={color} delay={0.4} />
    </div>
  );
};
